import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from '../../shared/services/cache.service';
import { AnonymousRetailSalesConstants } from '../constants/anonymous-retail-orders.constants';
import { RetailBonusReqValues, RetailBonusResponse, RetailStoreResponse } from '../interface/anonymous-retail-orders.interface';

@Injectable()
export class AnonymousRetailOrderService {

  constructor(private _http: Http,private _cacheService: CacheService) { }
  
  private handleErrorObservable(error: Response | any) {
    return Observable.throw(error);
  }


/**
 * 
 * @param retailBonusObj 
 * get Retail bonus sales record based on retailbonusObj param 
 */
  getRetailBonusSales(retailBonusObj: RetailBonusReqValues):Observable<RetailBonusResponse> {


    let url = ApiUrlConstants.reportTitanBaseApiUrl + 'v1/anonymous-retail-sales?';
    url = url + (retailBonusObj.pageNumber ? 'pageNumber=' + retailBonusObj.pageNumber : 'pageNumber=' + AnonymousRetailSalesConstants.PageNumber);
    url = url + (retailBonusObj.pageSize ? '&numberOfRecords=' + retailBonusObj.pageSize : '&numberOfRecords=' + AnonymousRetailSalesConstants.PageSize);
    url = url + (retailBonusObj.sort ? '&sortOption=' + retailBonusObj.sort : '&sortOption=' + AnonymousRetailSalesConstants.DESC);
    if(retailBonusObj.storeID){
      url = url + '&storeid=' + retailBonusObj.storeID 
    }
    if(retailBonusObj.sortColumn){
      url = url + '&sortColumn=' + retailBonusObj.sortColumn 
    }
    if(retailBonusObj.year){
      url = url + '&year=' + retailBonusObj.year
    }
    if(retailBonusObj.month){
      url = url + '&month=' + retailBonusObj.month
    }


    return this._http
        .get(url)
        .pipe(map((res: any) => res.json()),
        catchError(this.handleErrorObservable));
}
/**
 * 
 * @param createRetailSalesObj 
 * Create Retail bonus sales record based on createRetailSalesObj param 
 */
  createRetailBonusSales(createRetailSalesObj) {
    let url = ApiUrlConstants.manageAccountApiGwUrl + 'anonymous-retail-sales';
    return this._http
      .post(url, createRetailSalesObj)
      .pipe(map((res: any) => res.json()),
        catchError(this.handleErrorObservable));
  }


/**
 * 
 * @param RetailSalesObj 
 * Update Retail bonus sales record based on RetailSalesObj param 
 */
  updateOrDeleteRetailBonusSales(RetailSalesObj,isDelete){
    let url = ApiUrlConstants.manageAccountApiGwUrl + 'anonymous-retail-sales/'+RetailSalesObj.id+'?isDelete='+isDelete+'&updatedBy='+RetailSalesObj.updatedBy;
    return this._http
    .put(url, RetailSalesObj)
    .pipe(map((res: any) => res.json()),
      catchError(this.handleErrorObservable));
  }

/**
 * get store details based on required month and year
 * @param month 
 * @param year 
 */
  getStoreDetails(month:number,year:number):Observable<RetailStoreResponse>{
    let url = ApiUrlConstants.reportTitanBaseApiUrl + 'v1/anonymous-retail-sales/stores?processingMonth='+month+'&processingYear='+year;
    return this._http
    .get(url)
    .pipe(map((res: any) => res.json()),
    catchError(this.handleErrorObservable));
  }
  
  /**
   * get retail participating stores
   */
  getRetailParticipatingStores():Observable<RetailStoreResponse> {
    let url = ApiUrlConstants.configurationApiUrl + 'stores/retail-participating-stores';
    return this._http
    .get(url)
    .pipe(map((res: any) => res.json()),
    catchError(this.handleErrorObservable));

  }

/**
 * 
 * @param salesID 
 * @param createdBy 
 * 
 */
 calculateOrderTotalCC(reqObj){
  let url = ApiUrlConstants.batchApiUrl+'file-upload'
   return this._http
    .post(url,reqObj)
    .pipe(map((res: any) => res.json()),
    catchError(this.handleErrorObservable));
 }

 approveRetailOrder(salesID:number,createdBy:number){
   let url =  ApiUrlConstants.batchApiUrl+'anonymous-retail-sales/approve/'+salesID+'?createdBy='+createdBy;
   return this._http
   .post(url,{})
   .pipe(map((res: any) => res.json()),
   catchError(this.handleErrorObservable));
 }
 
 reviseRetailOrder(salesID,revisedBy){
  let url = ApiUrlConstants.accountApiUrl +'anonymous-retail-sales/revise/'+salesID+'?revisedBy='+revisedBy;
  return this._http
   .get(url)
   .pipe(map((res: any) => res.json()),
   catchError(this.handleErrorObservable));
}

/**
 * check user has anonymous retail permissions
 * @param hasAnonymousRetailOrderPermission 
 */
  getAnonymousRetailAccess(hasAnonymousRetailOrderPermission: number[]) {
    const userInfo = this._cacheService.get(CacheKey.UserInfo);
    let isAllowed: boolean = false;
    if (userInfo && userInfo.hasSystemRole) return isAllowed = true;
    if (userInfo && userInfo.privileges && userInfo.privileges.stores && userInfo.privileges.stores.length > 0) {
      const userStorePermissions: any[] = userInfo.privileges.stores;
      for (let i = 0; i < hasAnonymousRetailOrderPermission.length; i++) {
        userStorePermissions.some((store: any) => isAllowed = store.permissions.includes(hasAnonymousRetailOrderPermission[i]));
        if (isAllowed) break;
      }
    }
    return isAllowed;
  }

  getUsersDetails(userIds){
    let url = ApiUrlConstants.enrollmentApigwUrl + 'user-details?userIds=' + userIds;
    return this._http
      .get(url)
      .pipe(map((res: any) => res.json()),
      catchError(this.handleErrorObservable));
  }

  getOrderdetails(anonymousRetailSalesId: number, pageSize: number, pageNumber: number){
    let url = ApiUrlConstants.reportTitanBaseApiUrl + 'v1/anonymous-retail-sales/' + anonymousRetailSalesId + '/order-details?pageSize=' + pageSize + '&pageNumber=' + pageNumber;
    return this._http
      .get(url)
      .pipe(map((res: any) => res.json()),
      catchError(this.handleErrorObservable));
  }

  regenerateOrders(initiateOrder){
    let url = ApiUrlConstants.batchApiUrl + 'anonymous-retail-sales/initiate-order';
    return this._http
      .post(url, initiateOrder)
      .pipe(map((res: any) => res.json()),
        catchError(this.handleErrorObservable));
  }

  getLogDetails(retailSalesId:number|string){
    let url = ApiUrlConstants.accountApiUrl +'anonymous-retail-sales/'+retailSalesId+'/log-details';
    return this._http
      .get(url)
      .pipe(map((res: any) => res.json()),
        catchError(this.handleErrorObservable));
  }
  
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/anonymous-retail-order.service.ts